// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createStore } from "effector";
import { TemplateDTO } from "../../utils/htmlTemplate/dto/template.dto";
import { setTemplates } from "./TemplateEvents";

export const TemplateStore = createStore<TemplateDTO[]>([]).on<TemplateDTO[]>(
  setTemplates,
  (state: TemplateDTO[], payload: TemplateDTO[]) => payload
);
